import { Item } from 'tacho-ui';
import { LicenseTachoModule } from '../../../../core/domainModels/modules/LicenseTachoModule';
import { TachoModule } from '../../../../core/domainModels/modules/TachoModule';

function arrayMove(arr: Array<any>, fromIndex: number, toIndex: number) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
    return arr;
}

export const mapModulesIdsToItems = (allowedModules: Array<LicenseTachoModule>, modules: Array<TachoModule>): Array<Item> => {
    let array = modules.map(module => ({
        id: module.id,
        label: module.name || '',
        checked: allowedModules.map(item => item.tachoModuleId)?.includes(module.id),
        additionalValue: allowedModules.find(item => item.tachoModuleId === module.id)?.maximumLoggedUsers || 1,
    }));
    return arrayMove(array, 1, 2);
};
